import { render, staticRenderFns } from "./ServiceQuotationItem.vue?vue&type=template&id=087526fb&scoped=true&"
import script from "./ServiceQuotationItem.vue?vue&type=script&lang=js&"
export * from "./ServiceQuotationItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceQuotationItem.vue?vue&type=style&index=0&id=087526fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087526fb",
  null
  
)

export default component.exports